module.exports = __webpack_public_path__ + "img/logo-light.d7bb227d.svg";